const MINOR_WORDS = new Set(["a", "an", "and", "as", "at", "by", "for", "in", "of", "on", "or", "per", "the", "to", "via", "with"]);

/**
 * Title Case for display labels ("blood group" -> "Blood Group").
 * Only lowercase-initial Latin words are changed, so acronyms (QR, ID, DRABC),
 * values like "B+" and non-Latin scripts (Hindi) are left untouched.
 */
export function toTitleCase(text) {
  if (typeof text !== "string" || !text) return text;
  let wordIndex = 0;
  return text.replace(/[A-Za-z][A-Za-z']*/g, (word) => {
    const isFirst = wordIndex === 0;
    wordIndex += 1;
    if (!/^[a-z]/.test(word)) return word;
    if (!isFirst && MINOR_WORDS.has(word)) return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
}
